// import transformer from 'transformers/account';
// import store from 'store';
import { makeRequest } from 'utils/requestLogger';
// import config from '../apiConfigs';

export default () => makeRequest('get', '/api/users/me');



// WEBPACK FOOTER //
// ./src/app/services/account/completeInfo.js